import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchFormSwitch } from '../SearchFormSwitch';
import { useDispatch, useSelector } from 'react-redux';
import { isOfferHotels } from '../../../../store/offerHotels/selectors';
import { offerHotelsAction } from '../../../../store/offerHotels/actions';

const OfferHotels: React.FC = props => {
	const { t } = useTranslation('SearchForm');

	const isOfferHotelsActive = useSelector(isOfferHotels),
		dispatch = useDispatch();

	const toggleOfferHotels = () => {
		dispatch(offerHotelsAction(!isOfferHotelsActive));
	};

	return (
		<SearchFormSwitch
			checked={isOfferHotelsActive}
			onChange={toggleOfferHotels}
			label={t('Offer hotels')}
			inverted={isOfferHotelsActive}
			dataTestId="offer-hotels-toggle"
		/>
	);
};

export default OfferHotels;
